import React, {Component} from "react"

import RewardCatalogueRewardQuery, {RewardCatalogueQueryResponse} from "@irati/reward/apollo/query/RewardCatalogueReward"
import {RewardDetailRouteProps} from "@irati-web/reward/src/types"
import NotFound from "@irati-web/reward/src/components/NotFound"
import {RewardDetailWrapper} from "@irati-web/reward/src/components/Detail"
import {rewardTracking} from "@irati-tracking/reward"
import {Reward} from "@irati/types"

import Layout from "@irati-web/recognition/src/components/Layout"

interface State {
  isMobileSummaryShown: boolean,
  isTermsAndConditionsShown: boolean
}

class RewardDetailContainer extends Component<RewardDetailRouteProps, State> {
  onCompletedRewardCatalogueReward = ({rewardCatalogueReward}: { rewardCatalogueReward: Reward }) => {
    if (rewardCatalogueReward.isCredit) {
      rewardTracking.rewardsTabStartSendCredit()
    }
    rewardTracking.rewardsTabViewRewardDetails(rewardCatalogueReward)
  }

  render() {
    const {slug} = this.props.match.params

    return (
      <Layout>
        <RewardCatalogueRewardQuery
          onCompleted={this.onCompletedRewardCatalogueReward}
          variables={{rewardId: slug}}
          useLoader>
          {({data}: RewardCatalogueQueryResponse) => {
            const reward = data && data.rewardCatalogueReward
              ? data.rewardCatalogueReward
              : null

            if (!reward) {
              return (
                <NotFound
                  buttonHref="/reward"
                  buttonText="reward.detail.notFound.button" />
              )
            }

            return <RewardDetailWrapper reward={reward} />
          }}
        </RewardCatalogueRewardQuery>
      </Layout>
    )
  }
}

export default RewardDetailContainer
